import React, { useEffect, useState } from 'react';
import Button from '../../../components/Common/Button';
import { setBookDataModified } from '../../../store/appSlice';
import { AppDispatch, RootState } from '../../../store/store';
import { useDispatch, useSelector } from 'react-redux';
import { updateSummary } from '../services/story.service';
import { EditStorySummaryProps } from '../models/EditStorySummaryProps.interface';

export const EditStorySummary = ({
                                   summary,
                                   type,
                                   closeSummaryModal,
                                   displayBookPages,
                                   targetRefs,
                                   summaryId
                                 }: EditStorySummaryProps) => {
  const [summaryText, setSummaryText] = useState<string>('');
  const [loader, setLoader] = useState<boolean>(false);
  const bookId = useSelector((state: RootState) => state.app.bookId);
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    setSummaryText(summary);
  }, [summary]);

  const handleUpdateSummary = async () => {
    await updateSummary({
      bookId,
      summaryText,
      setLoader,
      dispatch,
      displayBookPages,
      setBookDataModified: () => dispatch(setBookDataModified(true)),
      closeSummaryModal,
      targetRefs
    });
  };

  return (
    <>
      <div className="text-left m-2 mb-8 text-sm text-storyblue animate__animated animate__slideInRight">
        <div className="flex flex-col gap-2">
          <h2 className="text-left text-2xl md:text-4xl mb-4 font-bold text-storyblue">Edit Summary</h2>
          <textarea
            autoFocus
            value={summaryText}
            onChange={(e) => {
              setSummaryText(e.target.value);
            }}
            className="h-36 md:h-96 text-lg md:text-2xl p-4 border-gray-400 border-2 text-gray-800 w-full"
          />
        </div>
        <div className="w-full flex justify-center flex-wrap gap-2 md:gap-4 mt-4">
          <Button
            title=" Close"
            onClick={() => {
              closeSummaryModal();
            }}
            className="submit-button flex justify-center gap-3 bg-storyblueSecondLightText text-white font-bold rounded-2xl px-4 py-2 text-base items-center"
          />
          <Button
            title={'Update Summary'}
            loader={loader}
            onClick={() => {
              handleUpdateSummary();
            }}
            className="submit-button flex justify-center gap-3 bg-storyblue text-white font-bold rounded-2xl px-4 py-2 text-base items-center"
          />
        </div>
      </div>
    </>
  );
};
